var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Twitter Icon",
    d: "M22.3214 0H2.67857C1.19978 0 0 1.19978 0 2.67857V22.3214C0 23.8002 1.19978 25 2.67857 25H22.3214C23.8002 25 25 23.8002 25 22.3214V2.67857C25 1.19978 23.8002 0 22.3214 0ZM19.5926 8.86161C19.6038 9.01786 19.6038 9.17969 19.6038 9.33594C19.6038 14.1741 15.9208 19.7489 9.19085 19.7489C7.11496 19.7489 5.18973 19.1462 3.57143 18.1083C3.86719 18.1417 4.15179 18.1529 4.45313 18.1529C6.1663 18.1529 7.73996 17.5725 8.99554 16.5904C7.38839 16.5569 6.03795 15.5022 5.57478 14.0513C6.13839 14.135 6.64621 14.135 7.22656 13.9844C5.55246 13.644 4.29688 12.1708 4.29688 10.3906V10.346C4.78237 10.6194 5.35156 10.7868 5.94866 10.8092C5.44667 10.4752 5.03515 10.0223 4.75082 9.4906C4.4665 8.95895 4.31821 8.36518 4.3192 7.76228C4.3192 7.08147 4.49777 6.45647 4.81585 5.91518C6.6183 8.13616 9.32478 9.58705 12.3605 9.7433C11.8415 7.26005 13.6998 5.24554 15.9319 5.24554C16.9866 5.24554 17.9353 5.68638 18.6049 6.40067C19.4308 6.24442 20.2232 5.9375 20.9263 5.51897C20.6529 6.36719 20.0781 7.08147 19.3192 7.53348C20.0558 7.45536 20.7701 7.24888 21.4286 6.96429C20.9319 7.69531 20.3069 8.34263 19.5926 8.86161Z",
    fill: "#918E9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.3a72c10735b2334e59c92482fc53351f.svg";
export { ForwardRef as ReactComponent };